var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCapital = function SvgCapital(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 51
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00A6FF",
    d: "M50.157 25.89c0 13.807-11.193 24.999-25 24.999-13.806 0-25-11.192-25-25s11.194-25 25-25c13.807 0 25 11.193 25 25"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M10.872 22.112h5.365m-2.682-3.462v6.924m2.372-10.605h7.124m-3.563-4.596v9.19M30.89 29.26c0 1.606-3.69 2.907-8.241 2.907s-8.242-1.301-8.242-2.908 3.69-2.908 8.242-2.908c4.55 0 8.241 1.302 8.241 2.908zm-16.116 3.758c-.239.273-.367.561-.367.86 0 1.606 3.689 2.909 8.241 2.909s8.243-1.303 8.243-2.908c0-.3-.129-.588-.368-.86m-15.749 4.619c-.239.272-.367.56-.367.86 0 1.606 3.689 2.908 8.241 2.908s8.243-1.302 8.243-2.908c0-.3-.129-.588-.368-.86"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M25.664 26.553V15.41h13.78v21.648m0-17.111-7.856 5.627m7.856 2.419-6.118 4.666"
  }))));
};
export default SvgCapital;